
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import MylobyLoadMore from "@/components/generic/load-more.vue";
import Timeout = NodeJS.Timeout;

const DEBOUNCE_TIME_MILLI: number = 500;

@Component({
  components: { MylobyLoadMore },
})
export default class CompanyKeysMultiAutocomplete extends Vue {

  @Prop({default: null})
  public companyId: number;

  @Prop({default: null})
  public initItem: any;

  private keys: any[] = [];
  private totalKeys: number = 0;
  private keysPagination = {
    page: 0,
    itemsPerPage: 10,
  };
  private keySearch: string = null;
  private loadingKeys: boolean = false;
  private selectedKeys: any[] = [];
  private timerId: Timeout = null;

  @Getter private envCompanyId: number|null;

  @Watch("keySearch", {immediate: false})
  public handleKeySearch() {
    return this.keySearch !== null
      ? this.getFirstKeysDelayed()
      : this.getFirstKeys();
  }

  get formattedKeysValues(): any[] {
    // Ensure selected keys are always visible
    const alreadySelected = this.selectedKeys
      .filter((selectedKey) => !this.keys.some((k) => k.id === selectedKey.id));
    return [...alreadySelected, ...this.keys];
  }

  private mounted(): void {
    if (this.initItem) {
      this.selectedKeys = [this.initItem];
      this.$emit("update", this.selectedKeys);
    }
    this.getFirstKeys();
  }

  private getFirstKeysDelayed(): void {
    this.loadingKeys = true;
    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      this.getFirstKeys();
    }, DEBOUNCE_TIME_MILLI);
  }

  private async getFirstKeys(): Promise<void> {
    this.keysPagination.page = 1;
    this.keys = [];
    await this.getKeysList();
  }

  private async getNextKeys(): Promise<void> {
    this.keysPagination.page++;
    await this.getKeysList();
  }

  private async getKeysList(): Promise<void> {
    this.loadingKeys = true;
    await this.$store.dispatch("bookings/getKeysForBooking", {
      // Filters
      companyId: this.envCompanyId,
      search : this.keySearch,
      excludeIds: this.selectedKeys.map(({ id }) => id),
      // Pagination
      page: this.keysPagination.page,
      itemsPerPage: this.keysPagination.itemsPerPage,
    }).then((res) => {
      this.keys = [...this.keys, ...res.rows];
      this.totalKeys = res.count || 0;
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loadingKeys = false;
    });
  }

  private async updatedSelectedKeys(): Promise<void> {
    this.$emit("update", this.selectedKeys);
    await this.getFirstKeys();
  }

  private removeItemFromSelectedKey(keyToRemove): void {
    this.selectedKeys = this.selectedKeys.filter((key) => key.id !== keyToRemove.id);
    this.updatedSelectedKeys();
  }
}
